/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Dialog} from "../models/dialog";
import {DialogService} from "../services/dialog.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class DialogsResolver implements Resolve<Dialog[]> {

  constructor(
    private mDialogService: DialogService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Dialog[]> {
    try {
      return await this.mDialogService.getAllDialogs();
    } catch (error) {
      console.error("Problem resolving Dialogs... Error: " + error, error);
    }
  }

}
